import { Hub } from '@shared/enums/hub';
import LocationLight from '@public/icons/location-white.svg';
import LocationDark from '@public/icons/location-dark.svg';
import LocationGreen from '@public/icons/location-green.svg';

export type HubButton = {
  title: string;
  id: Hub;
  defaultIcon: string;
  selectedIcon: string;
  selectedIconM: string;
};

const icons: Omit<HubButton, 'title' | 'id'> = {
  defaultIcon: LocationDark,
  selectedIcon: LocationLight,
  selectedIconM: LocationGreen,
};

export const hubButtons: HubButton[] = [
  { title: 'CHICAGO, IL', ...icons, id: Hub.Chicago },
  { title: 'COLUMBUS, OH', ...icons, id: Hub.Columbus },
  { title: 'GREENVILLE, SC', ...icons, id: Hub.Greenville },
  { title: 'RENO, NV', ...icons, id: Hub.Reno },
  { title: 'STOCKTON, CA', ...icons, id: Hub.Stockton },
  { title: 'DENVER, CO', ...icons, id: Hub.Denver },
  { title: 'FONTANA, CA', ...icons, id: Hub.Fontana },
];
